export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_03.80b8ad81.png";